import { ApplicationConfig, APP_INITIALIZER, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';

import { routes } from './app.routes';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslocoHttpLoader } from './transloco-loader';
import { TranslocoTitleStrategy } from './transloco-title.strategy';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import * as authEffects from './store/auth/auth.effects';
import * as newsEffect from './store/news/news.effects';
import { authFeature } from './store/auth/auth.reducer';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { TokenInterceptor } from './shared/services/token-interceptor.service';
import { AppComponent } from './app.component';
import { newsFeature } from './store/news/news.reducer';
import { firstValueFrom } from 'rxjs';
import { ThemeService } from './shared/theme/theme.service';

const savedLang = localStorage.getItem('lang');
const defaultLang =
  savedLang === 'it' || savedLang === 'en' ? savedLang : 'it';

function preloadTranslations(transloco: TranslocoService) {
  return () => firstValueFrom(transloco.load(defaultLang));
}

export const appConfig: ApplicationConfig = {
  providers: [
    AppComponent,
    provideRouter(routes),
    { provide: TitleStrategy, useClass: TranslocoTitleStrategy },
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideStore(),
    provideState(newsFeature),
    provideState(authFeature),
    provideEffects([authEffects, newsEffect]),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() , connectInZone: true}),

    provideTransloco({
      config: {
        availableLangs: ['it', 'en'],
        defaultLang,
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: preloadTranslations,
      deps: [TranslocoService],
      multi: true,
    },
    // Instantiate ThemeService at startup so it owns the theme from the first render.
    provideAppInitializer(() => {
      inject(ThemeService);
    }),
    provideAnimations(),
    provideToastr(),
    // provideTinyMce(),

    // importProvidersFrom([
    //     {
    //         provide: MAT_DATE_LOCALE, useValue: it
    //     }
    // ])
  ],
};
